"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuggestedOptionsMenu = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
var ReactUtils_1 = require("@CommonFrontend/Utils/ReactUtils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var LightDarkThemeProvider_1 = require("Utils/LightDarkThemeProvider");
var styles = __importStar(require("./SuggestedOptionsMenu.css"));
function useSuggestedOptionsMenu(props) {
    var _a = __read((0, react_1.useState)(false), 2), isMenuOpen = _a[0], setIsMenuOpen = _a[1];
    var _b = __read((0, react_1.useState)(), 2), overlay = _b[0], setOverlay = _b[1];
    var _c = (0, utils_1.useOverlayPosition)({
        offset: tokens_1.spacing.xs,
    }), targetRef = _c.targetRef, providedOverlayRef = _c.overlayRef, overlayProps = _c.overlayProps;
    var composedOverlayRef = (0, ReactUtils_1.composeRefs)([setOverlay, providedOverlayRef]);
    var wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!isMenuOpen || !overlay) {
            return;
        }
        var handleMouseDown = function (event) {
            var target = event.target;
            if (!overlay || !wrapperRef.current) {
                return;
            }
            if (target === null || !(target instanceof Element)) {
                return;
            }
            if (!overlay.contains(target) && !wrapperRef.current.contains(target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        return function () {
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, [overlay, isMenuOpen]);
    (0, react_1.useEffect)(function () {
        if (!isMenuOpen) {
            return;
        }
        var handleKeyDown = function (event) {
            if (event.key === utils_1.KeyType.Escape || event.key === utils_1.KeyType.Tab) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
        };
    });
    function openMenu() {
        if (!isMenuOpen) {
            setIsMenuOpen(true);
        }
    }
    function closeMenu() {
        setIsMenuOpen(false);
    }
    return {
        openMenu: openMenu,
        inputRef: targetRef,
        wrapperRef: wrapperRef,
        menuComponent: (react_1.default.createElement(MenuComponent, __assign({}, props, { closeMenu: closeMenu, isMenuOpen: isMenuOpen, composedOverlayRef: composedOverlayRef, overlayModifier: overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.modifier, overlayPosition: overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.overlay }))),
    };
}
exports.useSuggestedOptionsMenu = useSuggestedOptionsMenu;
function MenuComponent(_a) {
    var suggestedOptions = _a.suggestedOptions, currentValue = _a.currentValue, width = _a.width, onSelect = _a.onSelect, closeMenu = _a.closeMenu, isMenuOpen = _a.isMenuOpen, composedOverlayRef = _a.composedOverlayRef, overlayPosition = _a.overlayPosition, overlayModifier = _a.overlayModifier;
    var portalRoot = (0, utils_1.getPortalRoot)("suggested-options-overlay");
    var theme = (0, LightDarkThemeProvider_1.useLightDarkThemeContext)().theme;
    return (react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: isMenuOpen, timeout: kaleidoscope_1.AnimationDuration.Medium, onEnter: utils_1.forceReflow }, function (status) {
        return react_dom_1.default.createPortal(react_1.default.createElement(kaleidoscope_1.Layer, null, function (_a) {
            var zIndex = _a.zIndex;
            return (react_1.default.createElement(kaleidoscope_1.Panel, { theme: theme, className: ((0, classnames_1.default)(styles.panel({
                    status: status,
                    position: overlayModifier,
                })),
                    "nested-portal"), ref: composedOverlayRef, style: __assign(__assign({}, overlayPosition), { zIndex: zIndex, width: width }), "data-status": status },
                react_1.default.createElement("div", { className: styles.menuContent },
                    react_1.default.createElement(kaleidoscope_1.Stack, { padding: "xs", gap: "xxs" }, suggestedOptions.map(function (_a, index) {
                        var value = _a.value, displayName = _a.displayName;
                        return (react_1.default.createElement(kaleidoscope_1.MenuItem, { key: index, onClick: function () {
                                closeMenu();
                                onSelect(value);
                            }, selected: value === currentValue }, displayName !== null && displayName !== void 0 ? displayName : value));
                    })))));
        }), portalRoot);
    }));
}
